import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import isEqual from 'lodash-es/isEqual';

import intlShape from '@/shared/utils/intlShape';
import { DeleteIcon } from '@/shared/components/Icons';
import OkCancelModal from '../../../../shared/components/OkCancelModal';

import api from '../../../../shared/api';
import config from '../../../../config';
import { getDocumentTypes } from '../../Documents/documentTypesService';

const messages = defineMessages({
  SelectDocumentTypeToAdd: 'Select type to add',
});

class EditDocumentTagTypesDialog extends PureComponent {
  constructor(props) {
    super(props);

    const { types } = props;

    this.state = {
      types: [...types],
      documentTypes: [],
    };
  }

  componentDidMount() {
    const { intl } = this.props;
    getDocumentTypes(intl).then(documentTypes => {
      this.setState({ documentTypes });
    });
  }

  addType = e => {
    const type = e.target.value;
    if (!type) return;

    this.setState(({ types }) => ({
      types: [...types, parseInt(type)],
      selectedType: '',
    }));
  };
  removeType = type => {
    this.setState(({ types }) => ({
      types: types.filter(x => x !== type),
    }));
  };

  save = () => {
    const { types } = this.state;
    const { tagId, types: oldTypes, onClose } = this.props;
    if (isEqual(types, oldTypes)) {
      onClose(null); // Nothing changed
      return;
    }

    return api.base
      .put(`${config.appUrls.documents}/api/TagType/Types`, { tagId, types })
      .then(() => {
        onClose(types);
      });
  };

  render() {
    const { documentTypes, types } = this.state;
    const { onClose, intl, tagName } = this.props;

    const availableTypes =
      types && types.length > 0
        ? documentTypes.filter(x => types.indexOf(x.key) === -1)
        : documentTypes;

    const selectedTypes =
      types && types.length > 0 ? documentTypes.filter(x => types.indexOf(x.key) >= 0) : [];

    return (
      <OkCancelModal show title={tagName} onClose={() => onClose(null)} onSave={() => this.save()}>
        {availableTypes.length > 0 && (
          <div className="margin10B">
            <select className="form-control" value="" onChange={this.addType}>
              <option value="">{intl.formatMessage(messages.SelectDocumentTypeToAdd)}</option>
              {availableTypes.map(x => (
                <option key={x.key} value={x.key}>
                  {x.label}
                </option>
              ))}
            </select>
          </div>
        )}
        {selectedTypes.map(x => (
          <div key={x.key} className="pad5">
            <span className="margin5R">{x.label}</span>
            <DeleteIcon onClick={() => this.removeType(x.key)} />
          </div>
        ))}
      </OkCancelModal>
    );
  }
}

EditDocumentTagTypesDialog.propTypes = {
  tagId: PropTypes.string.isRequired,
  tagName: PropTypes.string.isRequired,
  types: PropTypes.arrayOf(PropTypes.number).isRequired,
  onClose: PropTypes.func.isRequired, // (newTypes)=>{}
  intl: intlShape.isRequired,
};

export default injectIntl(EditDocumentTagTypesDialog);
